import API from './API.js'

export default class PollsQuestions extends API {
  constructor(poll) {
    super(`polls/${poll}/questions`)
  }
}
